import React, { FormEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// import { socket } from 'src/components/socket'; // Assuming similar path
import { socket } from 'src/components/socket';
import { useSetRoomId } from 'src/common/recoil/room'; // Assuming Recoil state management
import { useModal } from 'src/modules/modal'; // Assuming custom hook for modals

import NotFoundModal from '../modals/NotFound';

const Home = (props:any):JSX.Element => {
  const { openModal } = useModal();
  const setAtomRoomId = useSetRoomId();
  const history = useNavigate(); // useHistory instead of useRouter

  // const {username, roomId, handleCreateRoom } = props

  const [roomId, setRoomId] = useState<string>('');
  const [username, setUsername] = useState<string>('');

  useEffect(() => {
    document.body.style.backgroundColor = 'white';
  }, []);

  useEffect(() => {
    socket.on('created', (roomIdFromServer: string) => {
      setAtomRoomId(roomIdFromServer);
      history(`/canvas/${roomIdFromServer}`); // Adjust the route as necessary
    });

    const handleJoinedRoom = (roomIdFromServer: string, failed?: boolean) => {
      if (!failed) {
        setAtomRoomId(roomIdFromServer);
        history(`/canvas/${roomIdFromServer}`); // Adjust the route as necessary
      } else {
        openModal(<NotFoundModal id={roomId} />);
      }
    };

    socket.on('joined', handleJoinedRoom);

    return () => {
      socket.off('created');
      socket.off('joined', handleJoinedRoom);
    };
  }, [openModal, roomId, history, setAtomRoomId]);

  useEffect(() => {
    socket.emit('leave_room');
    setAtomRoomId('');
  }, [setAtomRoomId]);

  const handleCreateRoom = () => {
    console.log(username)
    socket.emit('create_room', username);
  };

  const handleJoinRoom = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (roomId) socket.emit('join_room', roomId, username);
  };

  return (
    <div className="flex flex-col items-center py-24">
      <h1 className="text-5xl font-extrabold leading-tight sm:text-extra">
        Collabio
      </h1>
      <h3 className="text-xl sm:text-2xl">Real-time whiteboard</h3>

      {/* <div className="mt-10 flex flex-col gap-2">
        <label className="self-start font-bold leading-tight">
          Enter your name
        </label>
        <input
          className="input"
          id="username"
          placeholder="Username..."
          value={username}
          onChange={(e) => setUsername(e.target.value.slice(0, 15))}
        />
      </div> */}

      <div className="my-8 h-px w-96 bg-zinc-200" />

      <form
        className="flex flex-col items-center gap-3"
        onSubmit={handleJoinRoom}
      >
        <label htmlFor="room-id" className="self-start font-bold leading-tight">
          Enter room id
        </label>
        <input
          className="input"
          id="room-id"
          placeholder="Room id..."
          value={roomId}
          onChange={(e) => setRoomId(e.target.value)}
        />
        <button className="btn" type="submit">
          Join
        </button>
      </form>

      <div className="my-8 flex w-96 items-center gap-2">
        <div className="h-px w-full bg-zinc-200" />
        <p className="text-zinc-400">or</p>
        <div className="h-px w-full bg-zinc-200" />
      </div>

      <div className="flex flex-col items-center gap-2">
        <h5 className="self-start font-bold leading-tight">Create new room</h5>

        <button className="btn" onClick={handleCreateRoom}>
          Create
        </button>
      </div>
    </div>
  );
};

export default Home;
